import { configureStore } from "@reduxjs/toolkit";
import scrollSlice from "./scrollSlice";
import openNavbarSlice from "./openNavbarSlice";
import slaplanSlice from "./slaplanSlice";
import departmentSlice from "./departmentSlice";
import agentSlice from "./agentSlice";
import teamSlice from "./teamSlice";
import groupSlice from "./groupSlice";
import permissionSlice from "./permissionSlice";
import teamMemberSlice from "./teamMemberSlice";
import timezoneSlice from "./timezoneSlice";
import widgetSlice from "./widgetSlice";
import socialWidgetSlice from "./socialWidgetSlice";
import banListSlice from "./banListSlice";
import emailSettingSlice from "./emailSettingSlice";
import queueServiceSlice from "./queueServiceSlice";
import ticketPrioritySlice from "./ticketPrioritySlice";
import companySettingSlice from "./companySettingSlice";
import apiSettingSlice from "./apiSettingSlice";
import systemLogSlice from "./systemLogSlice";
import securitySettingSlice from "./securitySettingSlice";
import ticketSettingSlice from "./ticketSettingSlice";
import autoResponseSettingSlice from "./autoResponseSettingSlice";
import alertNoticeSettingSlice from "./alertNoticeSettingSlice";
import ticketStatusSlice from "./ticketStatusSlice";
import helpTopicSlice from "./helpTopicSlice";
import templateSetSlice from "./templateSetSlice";
import templateTypeSlice from "./templateTypeSlice";
import templatesSlice from "./templatesSlice";
import emailSlice from "./emailSlice";
import workflowCloseSlice from "./workflowCloseSlice";
import ratingSlice from "./ratingSlice";
import systemSettingSlice from "./systemSettingSlice";
import dateTimeFormatSlice from "./dateTimeFormatSlice";
import kbCategorySlice from "./kbCategorySlice";
import kbArticleSlice from "./kbArticleSlice";
import kbPagesSlice from "./kbPagesSlice";
import kbSettingSlice from "./kbSettingSlice";
import cannedResponseSlice from "./cannedResponseSlice";
import organizationSlice from "./organizationSlice";
import kbArticleRelationshipSlice from "./kbArticleRelationshipSlice";
import authSlice from "./authSlice";
import ticketSlice from "./ticketSlice";
import ticketDashboardSlice from "./ticketDashboardSlice";
import reportSlice from "./reportSlice";
import notificationSlice from "./notificationSlice";
import ticketSourceSlice from "./ticketSourceSlice";
import cronSlice from "./cronSlice";
import notificationUpdateSlice from "./notificationUpdateSlice";
import notificationUpdateAllSlice from "./notificationUpdateAllSlice";
import ticketInboxSlice from "./ticketInboxSlice";

const store = configureStore({
  reducer: {
    scroll: scrollSlice,
    openNavbar: openNavbarSlice,
    slaplan: slaplanSlice,
    department: departmentSlice,
    agent: agentSlice,
    team: teamSlice,
    group: groupSlice,
    permission: permissionSlice,
    teamMember: teamMemberSlice,
    timezone: timezoneSlice,
    widget: widgetSlice,
    socialWidget: socialWidgetSlice,
    banList: banListSlice,
    emailSetting: emailSettingSlice,
    queueService: queueServiceSlice,
    ticketPriority: ticketPrioritySlice,
    companySetting: companySettingSlice,
    apiSetting: apiSettingSlice,
    systemLog: systemLogSlice,
    securitySetting: securitySettingSlice,
    ticketSetting: ticketSettingSlice,
    autoResponseSetting: autoResponseSettingSlice,
    alertNoticeSetting: alertNoticeSettingSlice,
    ticketStatus: ticketStatusSlice,
    helpTopic: helpTopicSlice,
    templateSet: templateSetSlice,
    templateType: templateTypeSlice,
    templates: templatesSlice,
    email: emailSlice,
    workflowClose: workflowCloseSlice,
    rating: ratingSlice,
    systemSetting: systemSettingSlice,
    dateTimeFormat: dateTimeFormatSlice,
    kbCategory: kbCategorySlice,
    kbArticle: kbArticleSlice,
    kbPages: kbPagesSlice,
    kbSetting: kbSettingSlice,
    cannedResponse: cannedResponseSlice,
    organization: organizationSlice,
    kbArticleRelationship: kbArticleRelationshipSlice,
    auth: authSlice,
    ticket: ticketSlice,
    ticketDashboard: ticketDashboardSlice,
    report: reportSlice,
    notification: notificationSlice,
    ticketSource: ticketSourceSlice,
    cron: cronSlice,
    notificationUpdate: notificationUpdateSlice,
    notificationUpdateAll: notificationUpdateAllSlice,
    ticketInbox: ticketInboxSlice,
  },
});

export default store;
